import { render } from "./SidebarRouteLink.vue?vue&type=template&id=26bcb424"
import script from "./SidebarRouteLink.vue?vue&type=script&lang=js"
export * from "./SidebarRouteLink.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__